import React, { useState, useEffect } from "react";
import axios from "axios";
import "./transaction.css";
import BackButton from "./BackButton";
import { FiClock, FiCheckCircle, FiXCircle, FiDollarSign, FiCreditCard } from "react-icons/fi";

const Withdraw = () => {
    const [withdrawals, setWithdrawals] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchWithdrawals = async () => {
            try {
                setIsLoading(true);
                const res = await axios.get("https://backend.aubattle.com/api/withdraw-history", {
                    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
                });
                setWithdrawals(res.data);
            } catch (error) {
                console.error("Failed to fetch withdrawals:", error);
                setError("Failed to load withdrawal history. Please try again later.");
            } finally {
                setIsLoading(false);
            }
        };
        fetchWithdrawals();
    }, []);

    const getStatusIcon = (status) => {
        switch(status.toLowerCase()) {
            case 'completed':
                return <FiCheckCircle className="status-icon completed" />;
            case 'failed':
                return <FiXCircle className="status-icon failed" />;
            default:
                return <FiClock className="status-icon pending" />;
        }
    };

    const getMethodIcon = (method) => {
        switch(method.toLowerCase()) {
            case 'jazzcash':
            case 'easypaisa':
                return <FiCreditCard className="method-icon" />;
            default:
                return <FiDollarSign className="method-icon" />;
        }
    };

    return (
        <div className="withdraw-history-container">
            <div className="withdraw-history-header">
                <BackButton darkMode />
                <h2 className="withdraw-history-title">Withdrawal History</h2>
            </div>

            {isLoading ? (
                <div className="loading-container">
                    <div className="loading-spinner"></div>
                    <p>Loading transactions...</p>
                </div>
            ) : error ? (
                <div className="error-message">
                    <FiXCircle className="error-icon" />
                    <p>{error}</p>
                </div>
            ) : withdrawals.length === 0 ? (
                <div className="empty-state">
                    <div className="empty-icon">
                        <FiDollarSign />
                    </div>
                    <h3>No Withdrawals Yet</h3>
                    <p>Your withdrawal history will appear here once you make transactions</p>
                </div>
            ) : (
                <div className="withdraw-history-table-container">
                    <table className="withdraw-history-table">
                        <thead>
                            <tr>
                                <th>Amount</th>
                                <th>Method</th>
                                <th>Status</th>
                                <th>Date</th>
                            </tr>
                        </thead>
         <tbody>
                            {withdrawals.map((withdrawal) => (
                                <tr key={withdrawal._id}>
                                   <td className="amount-cell">
            <span className="amount-badge">{withdrawal?.amount}</span>
            <span className="currency">Coins</span>
        </td>
                                    <td>{getMethodIcon(withdrawal.method)} {withdrawal.method}</td>
                                    <td className={withdrawal.status.toLowerCase()}>{getStatusIcon(withdrawal.status)} {withdrawal.status}</td>
                                    <td>{new Date(withdrawal.created_at).toLocaleDateString()}</td>
                                </tr>
                            ))}
                        </tbody>

                    </table>
                </div>
            )}
        </div>
    );
};

export default Withdraw;